import { call, put, takeLatest } from "redux-saga/effects";
import { authAPI } from "../api/auth.api";
import { AuthActionTypes } from "../actions/actionTypes";
import { Action } from "../../../actions/actions";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { responseCodePipe } from "../../../services/code_matcher/response_code_pipe.service";
import { authMessagesStrings } from "../assets/authMessages.strings";
import { loginSignupFailMessages } from "../assets/errorMessages.strings";

function* recover(action: Action) {
    try {
        const data = yield call(authAPI.recover, action.payload.email);

        yield put({
            type: AuthActionTypes.RECOVER_SUCCESS,
            payload: data
        });

        yield put({
            type: AuthActionTypes.SHOULD_REDIRECT
        });
    } catch (e) {
        yield put({
            type: AuthActionTypes.RECOVER_FAIL,
            error: e.response.data.code
        });
    }
}

export function* recoverActionWatcher() {
    yield takeLatest(AuthActionTypes.RECOVER, recover);
}

function* recoverActionSuccess(_action: Action) {
    ToasterService.successToast(authMessagesStrings.RECOVER_SUCCESS);
}

export function* recoverSuccessWatcher() {
    yield takeLatest(AuthActionTypes.RECOVER_SUCCESS, recoverActionSuccess);
}

function* recoverActionFail(action: Action) {
    ToasterService.errorToast(
        responseCodePipe(action.error, loginSignupFailMessages)
    );
}

export function* recoverFailWatcher() {
    yield takeLatest(AuthActionTypes.RECOVER_FAIL, recoverActionFail);
}
